module.exports = __webpack_public_path__ + "static/media/OralMedicineRadiologyBDS.80f64d10.pdf";